import { connect } from 'react-redux';

import * as organizationConstants from '../../../constants/organizations';
import AddMemberTrigger from '../../../components/addMember/AddMemberTrigger';

const mapDispatchToProps = dispatch => ({
    showAddMembers: () =>
        dispatch({
            type: organizationConstants.TOGGLE_ADD_MEMBER,
            payload: { isAddMember: true },
        }),
});

export default connect(
    undefined,
    mapDispatchToProps,
)(AddMemberTrigger);



// WEBPACK FOOTER //
// ./src/containers/organizationMembers/addOrganizationMembers/AddOrganizationMembersTrigger.js